import type { Chat } from "@ai-sdk/react";
import { useChat } from "@ai-sdk/react";
import type { UIMessage } from "ai";
import { useEffect } from "react";

import ChatErrorBanner from "./ChatErrorBanner";
import ChatMessageList from "./ChatMessageList";
import describeToolActivity from "~/utils/describeToolActivity";
import isAwaitingAnswerText from "~/utils/isAwaitingAnswerText";

interface ChatConversationProps {
	chat: Chat<UIMessage>;
	onStatusChange: (status: string) => void;
}

const ChatConversation = ({ chat, onStatusChange }: ChatConversationProps) => {
	const { messages, status, error } = useChat({ chat });

	useEffect(() => {
		onStatusChange(status);
	}, [status, onStatusChange]);

	return (
		<div className="flex flex-1 flex-col overflow-hidden">
			<ChatMessageList
				messages={messages}
				isThinking={isAwaitingAnswerText(messages, status)}
				activity={describeToolActivity(messages)}
			/>
			{error && <ChatErrorBanner error={error} />}
		</div>
	);
};

export default ChatConversation;
